import { Pipe, PipeTransform } from '@angular/core';
import { AdvisorManagement } from 'src/models/workshopsManagement.interface';
;
@Pipe({
    name: 'filterAdvisors',
    standalone: false
})
  export class FilterAdvisorsPipe implements PipeTransform {
    transform(items:(AdvisorManagement[] | null),advisorName: string, brandName:string, typeOfService: string,workshopName: string): AdvisorManagement[] {
        if (!items) {
            return [];
          }
          if (!workshopName && !advisorName && !typeOfService && !brandName ) {
            return items;
          }
          //  change de words a lower case example ASD = asd
        advisorName =advisorName.toLowerCase();
        typeOfService = typeOfService.toLowerCase();
        brandName = brandName.toLowerCase()
        workshopName = workshopName.toLowerCase()
        
        return items.filter(item => {
          // Filter the objects by the workshop name and city name
          const nameMatch = item.advisorName.toLowerCase().includes(advisorName);
          const brandNameMatch= item.brands.find((item) => item.brandName.toLowerCase().includes(brandName) &&  item.isActive === true )!== undefined
          const typeOfServiceMatch =  item.services.find((item)=>item.serviceName.toLowerCase().includes(typeOfService) && item.isActive) !== undefined
          const workshopNameMatch = item.workshopName.toLowerCase().includes(workshopName);
          return nameMatch  && brandNameMatch && typeOfServiceMatch && workshopNameMatch;
        });
      
    }
  }